import { gql } from '@apollo/client';
import { AccountFragment } from 'shared/domains/users/utils/fragments';
export const setupCompanyMutation = gql `
  mutation CreateAdditionalCompany($companyName: String!, $companyMarketCode: String!, $userId: String!) {
    account: createCompanyUser2(
      input: { role: owner, userId: $userId, company: { name: $companyName, marketCode: $companyMarketCode } }
    ) {
      ...AccountFragment @unmask
    }
  }
  ${AccountFragment}
`;
